import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import GenericListPair from 'modules/common/components/GenericListPair';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import useDebounce from 'modules/common/components/UseDebounce';
import * as actions from '../action';
import * as c from '../constant';
import GradeLevelModal from '../modal/GradeLevelModal';
import GradeLevelContent from './GradeLevelContent';

const form = {
  keyword: '',
};

function GradeLevelContainer({
  match,
  history,
  getGradeLevelList,
  dataList,
  dataListPager,
  isLoading,
  removeGradeLevel,
  showGradeLevel,
}) {
  const [formData, setFormData] = useState(form);
  const setModal = useContext(ModalContext);

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <GradeLevelModal type="NEW" />,
      title: 'Add Grade Level',
      modalSize: 'modal-md',
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <GradeLevelModal dataInfo={data.attributes} dataId={data.id} type="EDIT" />,
      title: 'Update Grade Level',
      modalSize: 'modal-md',
    });
  };

  const handleRemove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to remove?',
      () => {
        removeGradeLevel(data.id, () => {
          getGradeLevelList({}, (response) => {
            const id = _.get(response, 'data.0.id');
            history.push(`/social-ameliorations/settings/student/grade-levels/${id}`);
            showGradeLevel(id);
          });
        });
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  useEffect(() => {
    getGradeLevelList();
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const debouncedSearchTerm = useDebounce(formData, 500);

  const param = {
    q: formData.keyword,
    sort_by: 'asc',
    is_paginated: 1,
  }


  useEffect(() => {
    if (debouncedSearchTerm) {
      getGradeLevelList({ ...param, sort_by: 'desc' });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:dataId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="Grade Level / Years"
            getData={getGradeLevelList}
            setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search..."
            pathName={`${match.path}/:dataId?`}
            listName="Grade Level / Years"
            label="Grade Level / Years"
            renderItem={(item) => (
              <div className="px-3 py-3">
                <p> {_.get(item, 'attributes.name')} </p>
              </div>
            )}
            isLoading={isLoading}
            selected={params.dataId}
            data={dataList}
            dataPager={dataListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:dataId?`}
                    render={() => (
                      <GradeLevelContent
                        handleAddModal={handleAddModal}
                        handleEdit={handleEdit}
                        handleRemove={handleRemove}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:dataId?`}
                  render={() =>
                    !params.dataId && dataList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(dataList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

GradeLevelContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getGradeLevelList: PropTypes.instanceOf(Function).isRequired,
  dataList: PropTypes.instanceOf(Array).isRequired,
  dataListPager: PropTypes.instanceOf(Object).isRequired,
  removeGradeLevel: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  showGradeLevel: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  dataList: _.get(api, `${c.GET_GRADE_LEVELS}.list`) || [],
  dataListPager: _.get(api, `${c.GET_GRADE_LEVELS}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_GRADE_LEVELS) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(GradeLevelContainer);
